var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border-bottom":"1px solid #262626","height":"1px","max-width":"90%","margin":"30px auto"}})}
var staticRenderFns = []

export { render, staticRenderFns }